module.exports = __webpack_public_path__ + "img/ca_visa.0c542eeb.png";